// ----
// JS for theme Close button for Remove Orcid Id modal
// ----
var Theme = Theme || {};

Theme.OrcidId = (function ($) {

    return {
        init: _init
    }

    function _init() {
        if (!_myComponentIsOnPage()) {
            return;
        }

        addCloseModalLogic();

        $(document).on('click', '.js-remove-orcid', function () {
            removeOrcidId();
        });

    }

    function _myComponentIsOnPage() {
        return $('.js-remove-orcid').length;
    }

    function addCloseModalLogic() {
        $(document).ready(function () {

            $('#removeOrcidIdDiv .js-cancel-orcid').click(function (e) {
                e.preventDefault();
                closeRevealModal();
            });

        });
    }

    function closeRevealModal() {
        $('#removeOrcidIdDiv').removeClass('open')
    }

    function removeOrcidId() {
        var url = '/UserDashboard/RemoveOrcidId';
        SCM.Ajax.post(url)
            .expectJson()
            .then(function (result) {
                if (result.Success) {
                    window.location.reload();
                }
                else {
                    if (result.Messages.length > 0) {
                        var $errorMessage = $('.error-message');
                        $errorMessage.html(result.Messages[0]);
                        $errorMessage.removeClass('hide');
                        closeRevealModal();
                    }
                }
            });
    }

})(jQuery);